module.exports = __webpack_public_path__ + "static/media/secao-2-bg.1bc0f046.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-2-bg.png
// module id = 907
// module chunks = 5